import { RouteConfig } from 'vue-router';

import RouterView from '@/components/layout/Router.vue';
import { mailTemplateAddRoute } from './mailTemplate/add.route';
import { mailTemplateEditRoute } from './mailTemplate/edit.route';
import { mailTemplatesRoute } from './mailTemplate/mailTemplates.route';

export const mailTemplateContainerRoute: RouteConfig = {
  path: 'mail-template',
  component: RouterView,
  children: [mailTemplatesRoute, mailTemplateAddRoute, mailTemplateEditRoute],
  meta: {
    config: {
      title: 'menu.mail-templates',
      name: 'mailTemplates',
      icon: 'fa-envelope',
      permissions: ['MAIL_TEMPLATE.LIST'],
      group: 'Ustawienia'
    },

    breadcrumb: {
      title: 'breadcrumbs.mail-templates.list',
      name: 'mailTemplates'
    }
  }
};
